import * as React from "react";
import { cn } from "@/lib/utils";

/**
 * A plain native checkbox, styled — not a Radix primitive, matching `select.tsx`'s reasoning.
 * Nothing here needs indeterminate state or a custom indicator, and native gives free
 * keyboard and touch behaviour on a phone for no bundle at all.
 */
export function Checkbox({ className, ...props }: React.ComponentProps<"input">) {
  return (
    <input
      type="checkbox"
      className={cn(
        "h-5 w-5 shrink-0 cursor-pointer rounded border-input accent-primary " +
          "focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring " +
          "disabled:cursor-not-allowed disabled:opacity-50",
        className,
      )}
      {...props}
    />
  );
}

/** A checkbox with its label and explanation, laid out for a thumb. */
export function CheckboxRow({
  label,
  description,
  checked,
  disabled,
  onChange,
}: {
  label: string;
  description?: string;
  checked: boolean;
  disabled?: boolean;
  onChange: (checked: boolean) => void;
}) {
  return (
    <label className="flex cursor-pointer items-start gap-3 py-1">
      <Checkbox
        className="mt-0.5"
        checked={checked}
        disabled={disabled}
        onChange={(e) => onChange(e.target.checked)}
      />
      <span>
        <span className="block text-sm font-medium">{label}</span>
        {description && <span className="block text-xs text-muted-foreground">{description}</span>}
      </span>
    </label>
  );
}
